import { useWishlistLists } from '@components/Universals/WishlistModifier/useWishlistLists';
import { GTM_WISHLIST_PAGE_TYPE } from '@containers/WishList/constants';
import { dispatchTrackingEvent } from '@context/tracking/utils';

export const trackWishlistPageView = (isNewWishlist: boolean) => {
  const defaultListId = useWishlistLists.DEFAULT_LIST_ID;

  const pathname = window.location.pathname;
  const lastPart = pathname.split('/').pop();
  const path =
    lastPart === defaultListId
      ? pathname
      : pathname.replace(/\/wishlist\/.*/, '/wishlist/custom');

  dispatchTrackingEvent({
    event: 'page_view',
    page: {
      title: 'Wishlist',
      path,
      unified_name: 'wishlist',
      type: GTM_WISHLIST_PAGE_TYPE,
      subpage: undefined,
      ...(isNewWishlist && { referrer: document.referrer }),
    },
    _clear: true,
  });
};

export const trackWishlistChange = ({
  products,
  productCount,
  interaction,
}: {
  products: { product_code: string }[];
  productCount: number;
  interaction: 'remove_button' | 'move_button' | 'product_add';
}) => {
  dispatchTrackingEvent({
    event: 'wishlist_change',
    wishlist: {
      product_count: productCount,
      interaction,
      products,
    },
    _clear: true,
  });
};
